module.exports = __webpack_public_path__ + "img/1000.00ff79a4.png";